import { InputBoX, SearchData, TableHead } from "../../../../common/dataClass/Default"

class ServiceSupplier{
  constructor() {
    this.id = ''
    /**名称 */
    this.name = ''
    /**星级 */
    this.star = ''
    /**地址 */
    this.province = ''
    this.city = ''
    this.county = ''
    this.location = ''
    /**联系人 */
    this.concatName = ''
    /**手机号 */
    this.phone = ''
    this.telPhone = ''
    this.qq = ''
    /**旺旺号 */
    this.aliNum = ''
    /**服务类型 */
    this.type = ''
    /**创建/修改时间 */
    this.time = ''
    /**备注信息 */
    this.remark = ''
  }
  /**后端返回的详情数据 */
  backendDetailDataParsing(){

  }
}

class ServiceSupplierSearchData extends SearchData{
  constructor() {
    super()
    this.time = null
  }
}

class ServiceSupplierInputBox extends InputBoX{
  constructor(type, name, data, obj = { isRequired: false }){
    super(type, name, data, obj)
    /**是否必填 */
    this.isRequired = obj.isRequired == undefined ? true : obj.isRequired
  }
}

class ServiceSupplierTableHead extends TableHead{
  constructor(name, prop, width, obj) {
    super(name, prop, width, obj)
  }
}

class ServiceSupplierInputBoxNewModule{
  static NEWTABLEHEAD(){
    let arr = [
      new ServiceSupplierTableHead('服务供应商ID', 'id', '150'),
      new ServiceSupplierTableHead('服务供应商名称', 'name', '150'),
      new ServiceSupplierTableHead('服务供应商地址', 'detailLocation', '150'),
      new ServiceSupplierTableHead('服务类型', 'type', '150'),
      new ServiceSupplierTableHead('联系人', 'concatName', '150'),
      new ServiceSupplierTableHead('手机号', 'phone', '150'),
      new ServiceSupplierTableHead('座机', 'telPhone', '150'),
      new ServiceSupplierTableHead('QQ', 'qq', '150'),
      new ServiceSupplierTableHead('旺旺号', 'aliNum', '150'),
      new ServiceSupplierTableHead('备注', 'remark', '150'),
      new ServiceSupplierTableHead('创建日期', 'time', '150'),
      new ServiceSupplierTableHead('操作', 'operate', '150'),
    ]
    return arr
  }
  static NEWSUPPLIERINPUTMODULE(){
    let obj = {
      name: new ServiceSupplierInputBox('text', '服务供应商名称', 'name', { isRequired: true, pla: '请输入供应商名称(可用简称或代号录入)' }),
      star: new ServiceSupplierInputBox('select', '服务供应商星级', 'star', { isRequired: true, pla: '' }),
      location: new ServiceSupplierInputBox('location', '服务供应商地址', 'location', { isRequired: true, pla: '' }),
      type: new ServiceSupplierInputBox('select', '服务类型', 'type', { isRequired: true, pla: '' })
    }
    return obj
  }
  static NEWCONCATINPUTMODULE(){
    let obj = {
      concatName: new ServiceSupplierInputBox('text', '联系人', 'concatName', { isRequired: true, pla: '请输入联系人' }),
      phone: new ServiceSupplierInputBox('text', '手机号', 'phone', { isRequired: true, pla: '请输入手机号' }),
      telPhone: new ServiceSupplierInputBox('text', '座机', 'telPhone', { isRequired: false, pla: '请输入座机号码' }),
      qq: new ServiceSupplierInputBox('text', 'QQ', 'qq', { isRequired: false, pla: '请输入QQ号码' }),
      aliNum: new ServiceSupplierInputBox('text', '旺旺号', 'aliNum', { isRequired: false, pla: '请输入旺旺号' }),
    }
    return obj
  }
  /**站外费用表头 */
  static NEWFEETABLEHEAD(){
    let arr = [
      new ServiceSupplierTableHead('图片', 'id', '80'),
      new ServiceSupplierTableHead('商品标题/ASIN/卖家SKU', 'name', '200'),
      new ServiceSupplierTableHead('产品名称/FNSKU', 'detailLocation', '150'),
      new ServiceSupplierTableHead('店铺名称', 'type', '100'),
      new ServiceSupplierTableHead('国家站点', 'concatName', '100'),
      new ServiceSupplierTableHead('商品包装尺寸<br>(cm)', 'phone', '150'),
      new ServiceSupplierTableHead('商品包装重量<br>(kg/单位)', 'telPhone', '150'),
      new ServiceSupplierTableHead('外箱包装尺寸<br>(cm)', 'qq', '150'),
      new ServiceSupplierTableHead('外箱包装重量<br>(kg/箱)', 'aliNum', '150'),
      new ServiceSupplierTableHead('服务供应商', 'remark', '150'),
      new ServiceSupplierTableHead('申请金额<br>(¥)', 'time', '150'),
      new ServiceSupplierTableHead('费用类型', 'operate', '150'),
      new ServiceSupplierTableHead('申请日期<br>划款日期', 'time', '200'),
      new ServiceSupplierTableHead('划款状态', 'operate', '150'),
      new ServiceSupplierTableHead('申请详情', 'operate', '150'),
    ]
    return arr
  }
  /**商品表头 */
  static NEWLISTINGTABLEHEAD(){
    let arr = [
      new ServiceSupplierTableHead('选择', 'check', '40'),
      new ServiceSupplierTableHead('图片', 'img', '80'),
      new ServiceSupplierTableHead('商品标题/ASIN/卖家SKU', 'model', '180'),
      new ServiceSupplierTableHead('商品名称/FNSKU', 'name', '150'),
      new ServiceSupplierTableHead('店铺名称', 'store', '80'),
      new ServiceSupplierTableHead('国家站点', 'getCountryName', '80'),
      new ServiceSupplierTableHead('商品包装尺寸<br>(cm)', 'productSize', '100'),
      new ServiceSupplierTableHead('商品包装重量<br>(kg/单位)', 'weight', '100'),
      new ServiceSupplierTableHead('外箱包装尺寸<br>(cm)', 'boxSize', '100'),
      new ServiceSupplierTableHead('外箱包装重量<br>(kg/单位)', 'boxWeight', '100'),
    ]
    return arr
  }
  /**站外费用申请进度条 */
  static NEWPROGRESSARRAY(){
    let arr = [
      '选择商品所属的店铺及国家站点',
      '选择对应的某一商品',
      '选择费用类别,服务供应商及输入申请金额',
      '点击生成推广费用申请单'
    ]
    return arr
  }
}

export {
  ServiceSupplier, ServiceSupplierInputBoxNewModule, ServiceSupplierInputBox, ServiceSupplierSearchData
}
